import React from 'react';

export default function Step1Disclosure({ form, setField }) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-gray-900">Disclosure & Privacy</h2>
      <p className="text-sm text-gray-500">
        Fields marked with <span className="font-semibold text-red-500">*</span> are required.
      </p>
      <label className="flex items-start gap-3 rounded-lg border border-gray-200 p-3">
        <input
          type="checkbox"
          checked={Boolean(form.consent_communication)}
          onChange={(e) => setField('consent_communication', e.target.checked)}
          className="mt-1 h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
        />
        <span className="text-sm text-gray-700">
          I consent to receive communication from my Agent and affiliated companies.{' '}
          <span className="text-red-500">*</span>
        </span>
      </label>
      <label className="flex items-start gap-3 rounded-lg border border-gray-200 p-3">
        <input
          type="checkbox"
          checked={Boolean(form.consent_truthful_information)}
          onChange={(e) => setField('consent_truthful_information', e.target.checked)}
          className="mt-1 h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
        />
        <span className="text-sm text-gray-700">
          I state that I am the person providing the information and I am providing the best answer
          to the best of my knowledge. <span className="text-red-500">*</span>
        </span>
      </label>
    </div>
  );
}
